<template>
  <div class="custom-container">
    <div>{{ $t('Typing.errorReview') + $t('Common.colon') }}</div>
    <b-row class="text-center">
      <b-col>
        正确答案（红色为你输入错误的或未输入的）
      </b-col>
      <b-col>
        你的輸入（红色为你输入错误的或多输入的）
      </b-col>
    </b-row>
    <b-row>
      <b-col class="block pl-0 pr-0">
        <vue-custom-scrollbar class="scroll-area">
          <span v-for="(ch, idx) in correctAnswer" :key="idx" :class="ch.className">{{ ch.ch }}</span>
        </vue-custom-scrollbar>
      </b-col>
      <b-col class="block pl-0 pr-0">
        <vue-custom-scrollbar class="scroll-area">
          <span v-for="(ch, idx) in judgedResult" :key="idx" :class="ch.className">{{ ch.ch }}</span>
        </vue-custom-scrollbar>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'TypingEssayTestReview',
  components: {
    vueCustomScrollbar
  },
  props: {
    correctAnswer: {
      type: Array,
      required: true
    },
    judgedResult: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
.custom-container {
  text-align: left;
  font-size: 16px;
}
.block {
  border: 1px solid;
}
.scroll-area {
  height: 300px;
  padding: 0px 5px;
}
.correct {
  color: #6bd089;
}
.incorrect {
  color: red;
  font-weight: 500;
}
</style>
